
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { validateInput } from "@/utils/securityUtils";

interface AddressFieldsProps {
  form: UseFormReturn<any>;
}

export function AddressFields({ form }: AddressFieldsProps) {
  return (
    <>
      {/* New enhanced address fields */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FormField
          control={form.control}
          name="houseNumber"
          render={({ field }) => (
            <FormItem>
              <FormLabel>House Number/Name</FormLabel>
              <FormControl>
                <Input placeholder="e.g. 123 or Flat 4B" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="street"
          render={({ field }) => (
            <FormItem className="md:col-span-2">
              <FormLabel>Street</FormLabel>
              <FormControl>
                <Input placeholder="Enter street name" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="townCity"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Town/City</FormLabel>
              <FormControl>
                <Input placeholder="Enter town or city" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="postcode"
          rules={{ 
            required: "Postcode is required",
            validate: (value) => validateInput.postcode(value) || "Please enter a valid UK postcode"
          }}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Postcode</FormLabel>
              <FormControl>
                <Input 
                  placeholder="Enter postcode" 
                  maxLength={10}
                  style={{ textTransform: 'uppercase' }}
                  {...field} 
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={form.control}
        name="address"
        rules={{ 
          required: "Full address is required",
          validate: (value) => validateInput.address(value) || "Please enter a valid address"
        }}
        render={({ field }) => (
          <FormItem>
            <FormLabel>Full Address (for display)</FormLabel>
            <FormControl>
              <Input 
                placeholder="Enter complete address" 
                maxLength={200}
                {...field} 
              />
            </FormControl>
            <FormDescription>
              This will be used for display purposes while the fields above will be used for automation
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
